// selectors.js
import { createSelector } from 'reselect';


const getDepart = (state) => state.DepartmentData.department;
export const selectDaparement = createSelector(
  [getDepart],
  (depart) => depart || { data: [] }
);

const getParytInwMemo = (state) => state.PartyInwData.pimemo;
export const selectPartyInwMemo = createSelector(
  [getParytInwMemo],
  (pimemo) => pimemo || { data: [] }
);

const getPartyInwData = (state) => state.PartyInwData.partyinw;
export const selectPartyInwData = createSelector(
  [getPartyInwData],
  (pimemo) => pimemo || { data: [] }
);

const getDeptEmp = (state) => state.DepartmentData.deptEmp;
export const selectDeptEmp = createSelector(
  [getDeptEmp],
  (deptEmp) => deptEmp || { data: [] }
);

const getPartyInwMemo = (state) => state.PartyInwData.partyinw2;
export const selectPartyInwDataMemo = createSelector(
  [getPartyInwMemo],
  (pimemo) => pimemo || { data: [] }
);